<template>
    <div class="sign-up-success">
        <div class="sign-up-success__header">
            <i class="fas fa-envelope"></i>
        </div>
        <div class="sign-up-success__body">
            <h1 class="sign-up-success__title">
                Confirm your account by checking your email.
            </h1>

            <transition name="resent">
                <p class="sign-up-success__paragraph" v-if="!resent">
                    If you don’t see the email in your inbox, check your spam folder or <a @click="retry">try again</a>.
                </p>
            </transition>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'SignUpSuccess',
        props: {
            email: String
        },
        data () {
            return {
                resent: false
            };
        },
        methods: {
            retry () {
                axios.post('/community/account_access', {
                    format: 'json',
                    member: {
                        email: this.email,
                        authenticity_token: document.querySelector('meta[name="csrf-token"]').content
                    }
                }).then(()=> {
                    this.resent = true;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "styleguidescss/utilities/_variables.scss";

.sign-up-success {
    margin: 30px auto;
    max-width: 450px;
    background: $white;
    box-shadow: 0px 2px 10px rgba(17, 17, 17, 0.15);
    border-radius: 5px;

    &__header {
        height: 200px;
        background: linear-gradient(180deg, #444444 0%, #333333 100%);
        border-radius: 5px 5px 0px 0px;
        text-align: center;
        i.fas {
            color: #FFF;
            font-size: 150px;
            line-height: 200px;
        }
    }

    &__body {
        padding: 30px;
    }

    &__title {
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        margin-bottom: 30px;
    }

    &__paragraph {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #333333;

        max-height: 40px;
        overflow: hidden;

        a {
            color: $blue;
            cursor: pointer;
        }
    }
}

.resent-enter-active, .resent-leave-active {
    transition: max-height 1s;
}
.resent-enter, .resent-leave-to /* .fade-leave-active below version 2.1.8 */ {
    max-height: 0;
}
</style>